import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "affald",
  "use": "affald-usage",
  "viewBox": "0 0 100 100",
  "content": "<symbol viewBox=\"0 0 100 100\" id=\"affald\"><path class=\"cls-1\" d=\"M61.73 29.65h5.91v56.78h-5.91zM48.16 29.65h5.91v56.78h-5.91zM34.59 29.65h5.91v56.78h-5.91z\" /><path class=\"cls-1\" d=\"M21 85.17a11.45 11.45 0 0 0 11.46 11.44h37.31A11.45 11.45 0 0 0 81.2 85.17v-65.7H21zm54.29-59.79v59.83a5.49 5.49 0 0 1-5.5 5.49H32.43a5.5 5.5 0 0 1-5.5-5.49V25.38zM67.63 12.69v-2.13a8 8 0 0 0-8-8h-17a8 8 0 0 0-8 8v2.13H21v5.91h60.2v-5.91zm-27.13 0v-2.13a2.14 2.14 0 0 1 2.14-2.14h16.94a2.13 2.13 0 0 1 2.15 2.14v2.13z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/affald.svg
// module id = 86Et
// module chunks = 1